export default {"src":"/_next/static/media/1_Arrow.ef174f04.svg","height":215,"width":200};